export const actionTypes = {
  SET_LOADING: 'SET_LOADING'
};

export const setLoading = loading => ({
  type: actionTypes.SET_LOADING,
  payload: loading
});

